// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top {
  padding-top: 3rem;
}

.btn-update {
  margin-top: 1rem;
}

.background-content {
  margin-top: 5rem;
  background-color: #fff;
  border-radius: 20px;
  padding: 40px;
  border: 1px solid #304269;
}
.background-content .form {
  display: flex;
  flex-flow: column;
  max-width: 700px;
  width: 100%;
  align-items: center;
}

h1 {
  font-size: 20px;
  font-weight: 500;
  line-height: 23.44px;
  text-align: center;
  color: #000000;
  text-wrap: nowrap;
  margin: 0px !important;
}

@media screen and (max-width: 500px) {
  .btn-update {
    margin-top: 2rem !important;
  }
  .background-content {
    padding: 30px;
  }
}
@media screen and (max-width: 1024px) {
  .wrapper-sign-in .container-banner {
    height: 45% !important;
  }
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInBhc3N3b3JkLXJlc2V0LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsaUJBQUE7QUFDRjs7QUFFQTtFQUNFLGdCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxnQkFBQTtFQUNBLHNCQUFBO0VBQ0EsbUJBQUE7RUFDQSxhQUFBO0VBQ0EseUJBQUE7QUFDRjtBQUNFO0VBQ0UsYUFBQTtFQUNBLGlCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxXQUFBO0VBQ0EsbUJBQUE7QUFDSjs7QUFHQTtFQUNFLGVBQUE7RUFDQSxnQkFBQTtFQUNBLG9CQUFBO0VBQ0Esa0JBQUE7RUFDQSxjQUFBO0VBQ0EsaUJBQUE7RUFDQSxzQkFBQTtBQUFGOztBQUdBO0VBQ0U7SUFDRSwyQkFBQTtFQUFGO0VBR0E7SUFDRSxhQUFBO0VBREY7QUFDRjtBQUlBO0VBQ0U7SUFDRSxzQkFBQTtFQUZGO0FBQ0YiLCJmaWxlIjoicGFzc3dvcmQtcmVzZXQuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIudG9wIHtcbiAgcGFkZGluZy10b3A6IDNyZW07XG59XG5cbi5idG4tdXBkYXRlIHtcbiAgbWFyZ2luLXRvcDogMXJlbTtcbn1cblxuLmJhY2tncm91bmQtY29udGVudCB7XG4gIG1hcmdpbi10b3A6IDVyZW07XG4gIGJhY2tncm91bmQtY29sb3I6ICNmZmY7XG4gIGJvcmRlci1yYWRpdXM6IDIwcHg7XG4gIHBhZGRpbmc6IDQwcHg7XG4gIGJvcmRlcjogMXB4IHNvbGlkICMzMDQyNjk7XG5cbiAgLmZvcm0ge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1mbG93OiBjb2x1bW47XG4gICAgbWF4LXdpZHRoOiA3MDBweDtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICB9XG59XG5cbmgxIHtcbiAgZm9udC1zaXplOiAyMHB4O1xuICBmb250LXdlaWdodDogNTAwO1xuICBsaW5lLWhlaWdodDogMjMuNDRweDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBjb2xvcjogIzAwMDAwMDtcbiAgdGV4dC13cmFwOiBub3dyYXA7XG4gIG1hcmdpbjogMHB4ICFpbXBvcnRhbnQ7XG59XG5cbkBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDUwMHB4KSB7XG4gIC5idG4tdXBkYXRlIHtcbiAgICBtYXJnaW4tdG9wOiAycmVtICFpbXBvcnRhbnQ7XG4gIH1cblxuICAuYmFja2dyb3VuZC1jb250ZW50IHtcbiAgICBwYWRkaW5nOiAzMHB4O1xuICB9XG59XG5cbkBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDEwMjRweCkge1xuICAud3JhcHBlci1zaWduLWluIC5jb250YWluZXItYmFubmVyIHtcbiAgICBoZWlnaHQ6IDQ1JSAhaW1wb3J0YW50O1xuICB9XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/auth/password-reset/password-reset.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AACF;AACE;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AACJ;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AAAF;;AAGA;EACE;IACE,2BAAA;EAAF;EAGA;IACE,aAAA;EADF;AACF;AAIA;EACE;IACE,sBAAA;EAFF;AACF;AACA,wtDAAwtD","sourcesContent":[".top {\n  padding-top: 3rem;\n}\n\n.btn-update {\n  margin-top: 1rem;\n}\n\n.background-content {\n  margin-top: 5rem;\n  background-color: #fff;\n  border-radius: 20px;\n  padding: 40px;\n  border: 1px solid #304269;\n\n  .form {\n    display: flex;\n    flex-flow: column;\n    max-width: 700px;\n    width: 100%;\n    align-items: center;\n  }\n}\n\nh1 {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 23.44px;\n  text-align: center;\n  color: #000000;\n  text-wrap: nowrap;\n  margin: 0px !important;\n}\n\n@media screen and (max-width: 500px) {\n  .btn-update {\n    margin-top: 2rem !important;\n  }\n\n  .background-content {\n    padding: 30px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .wrapper-sign-in .container-banner {\n    height: 45% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
